export default __webpack_public_path__ + "static/media/included-check-white.6e297f25.svg";